import { Injectable } from '@angular/core';
import { PingAuthService } from './ping-auth.service';
import { SharedService } from '../services/shared.service';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ConfigService } from '../services/config.service';
@Injectable({
  providedIn: 'root'
})
export class PreventionGuardService {

  environment: any;
  allowedRoutes: any;
  constructor( private readonly ping: PingAuthService,
    private readonly config: ConfigService) 
    { 
     this.environment = this.config.getConfig();
    }
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {     
    await this.ping.login();
    debugger;
     const hasAccess = await this.ping.verifyAccess(state.url, '/upload');
  return hasAccess
 }
}

















































/** Utility moved outside the class for clarity */
function normaliseGroups(groups: unknown): string[] {
  if (Array.isArray(groups)) {return groups};
  if (typeof groups === 'string') {return [groups]};
  return [];
}






// async canActivate(
//   route: ActivatedRouteSnapshot,
//   state: RouterStateSnapshot
// ): Promise<boolean> {
//   await this.ping.login();
//   // const token = sessionStorage.getItem("accessToken");
//   // if (!token) {
//   //   this.router.navigate(['/unauthorized']);
//   //   return false;
//   // }
//   try {
//     // Backend call (must return allowedRoutes[])
//     // const resp: any = await this.ping.verifyAccess(token);
//     const allowedRoutes = await this.ping.verifyAccess() || [];
//     // If backend returns empty array → logout and block
//     // if (allowedRoutes.length === 0) {
//     //   sessionStorage.clear();
//     //   this.router.navigate(['/login']);
//     //   return false;
//     // }
//     const currentRoute = route.routeConfig?.path ?? "";
//     // Allow only if backend returned this route
//     // if (allowedRoutes.includes(currentRoute)) {
//     //   return true;
//     // }
//     // Not allowed → logout or redirect
//     sessionStorage.clear();
//     this.router.navigate(['/unauthorized']);
//     return false;
//   } catch (err) {
//     sessionStorage.clear();
//     this.router.navigate(['/login']);
//     return false;
//   }
// }
// }

